export default __webpack_public_path__ + "static/media/signup06tour-slide2-A.4334d668.jpg";